import { useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Specifications from "./components/Specifications";
import Certification from "./components/Certification";
import Supply from "./components/Supply";
import Applications from "./components/Applications";
import ExportArgument from "./components/ExportArgument";
import Faq from "./components/Faq";
import SpecForm from "./components/SpecForm";
import Footer from "./components/Footer";

export default function Ingredients() {
  useEffect(() => {
    document.title =
      "Organic Non-Centrifugal Cane Sugar & Cocoa Powder Ingredients | Mesa Baja";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Certified organic unrefined cane sugar and cocoa powder ingredients from Colombia. Ecocert USDA and EU Organic, HACCP, CoA per batch. Full specification published."
      );
    }
  }, []);

  return (
    <main className="min-h-screen bg-cream">
      <Header />
      <Hero />
      <Specifications />
      <Certification />
      <Supply />
      <Applications />
      <ExportArgument />
      <Faq />
      <SpecForm />
      <Footer />
    </main>
  );
}